import { get_token } from "@/router";
import Swal from 'sweetalert2';

export default {
  mounted() {
    this.preview();
  },
  data: () => ({ 
    question_sections: [], 
    isLoading: false }),
  methods: {
    getToken() {
      return get_token();
    },
    preview() {

      const token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/view_form_sections/`,
        method: "POST",
        headers: token_exists
          ? { Authorization: `Token ${this.getToken()}` }
          : {},
          data: {
            form_id: this.$route.params.form_id,
          },
        success: (response) => {
          this.question_sections = response.sections;
        },
        error: () => {
          Swal.fire({
            icon: "error",
            title: "Failed to load question types",
          });
        },
      });
    },
  },
};



